'use client';

import { removeLastSlash } from '@/lib/utils';
import { ProgressProvider } from '@bprogress/next/app';
import { useLocale } from 'next-intl';

const comparePathname = (locale: string, url: URL) => {
  const pathname = url.pathname.startsWith(`/${locale}`) ? url.pathname : `/${locale}${url.pathname}`;
  return Object.assign(url, { pathname: removeLastSlash(pathname) });
};

export function ProgressBar() {
  const locale = useLocale();

  return (
    <ProgressProvider
      height="4px"
      color="#2299dd"
      options={{ showSpinner: false }}
      shallowRouting
      shouldCompareComplexProps={false}
      targetPreprocessor={(url) => comparePathname(locale, url)}
      disableStyle
    />
  );
}
